import { Declaracion } from './../../../models/declaracion.model';
import { Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup} from '@angular/forms';
import { FormService } from 'src/app/services/form.service';


declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-declaracion",
    templateUrl : "./declaracion.component.html",
    styleUrls : ["./declaracion.component.css"],
    providers: [FormService]
})

export class DeclaracionComponent {
    public rows = [];
      public actualRow;
      public declaracion: Declaracion;
      public form;

     
    constructor(public _formService: FormService, private fb:FormBuilder){
        this.form = new FormGroup({
            plano: new FormControl(''),
            denominado: new FormControl(''),
            elaborado: new FormControl(''),
            profesion: new FormControl(''),
        })

        if(!JSON.parse(localStorage.getItem("declaracion"))){
            localStorage.setItem("declaracion", JSON.stringify(this.rows));
        }else{  
            this.rows = JSON.parse(localStorage.getItem("declaracion"));
            this.form.controls['plano'].setValue(this.rows[0]?this.rows[0].plano:'NO');
            this.form.controls['denominado'].setValue(this.rows[0]?this.rows[0].denominado:'');
            this.form.controls['elaborado'].setValue(this.rows[0]?this.rows[0].elaborado:'');
            this.form.controls['profesion'].setValue(this.rows[0]?this.rows[0].profesion:'')
        }
       this.declaracion ={plano:'',denominado:'',elaborado:'',profesion:''}
    }

    add_declaracion(){
        //var checkDeclaracion = event.value;
        localStorage.setItem("declaracion", JSON.stringify([]))
        this.actualRow = localStorage.getItem("declaracion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            plano:  this.form.value.plano,
            denominado: this.form.value.denominado,
            elaborado: this.form.value.elaborado,
            profesion: this.form.value.profesion
        })
       
        localStorage.setItem("declaracion", JSON.stringify(this.rows));
        console.log(this.declaracion)
    }

    delete_declaracion(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("declaracion", JSON.stringify(this.rows));
            }
        }
    }
}